<template>
	<div class="chat-chat-game">
		<div class="chat-chat-game-title">
			<span class="chat-chat-ot-name"><span>{{chatUser.fans_wx_name}}</span>的游戏相关信息</span>
			<span class="chat-chat-ot-close" @click="closeOrder">关闭</span>
		</div>
		<div class="chat-chat-game-tabs">
			<div class="chat-chat-game-tab" :class="{'chat-chat-game-tab-active': type === 'role'}" @click="tabChange('role')">用户列表</div>
			<div class="chat-chat-game-tab" :class="{'chat-chat-game-tab-active': type === 'order'}" @click="tabChange('order')">消费记录</div>
		</div>
		<div class="chat-chat-game-wrap">
			<div v-if="type === 'role'">
				<chat-game-role 
					:chatUser="chatUser"
					@game-user-call="gameUserCall($event)"
					v-if="roleParam.type === 'role'">
				</chat-game-role>
				<chat-game-user 
					:chatUser="chatUser"
					@game-user-call="gameUserCall($event)"
					v-else-if="roleParam.type === 'user'">
				</chat-game-user>
			</div>
			<div v-else>
				<chat-game-order :chatUser="chatUser"> </chat-game-order>
			</div>
		</div>
	</div>
</template>

<script>
	import ChatGameRole from './game/ChatGameRole.vue'
	import ChatGameUser from './game/ChatGameUser.vue'
	import ChatGameOrder from './game/ChatGameOrder.vue'
	
	export default{
		name:"ChatChatGame",
		props:{
			chatUser:{
				type: Object,
				default: function(){
					return {}
				}
			}
		},
		components:{
			ChatGameRole,
			ChatGameUser,
			ChatGameOrder
		},
		data(){
			return {
				type: 'role',
				roleParam:{
					type:'role'
				}
			}
		},
		methods:{
			// 关闭页面
			closeOrder(){
				this.$emit('chat-game-close')
			},
			
			// tab切换
			tabChange(type){
				this.type = type
			},
			
			// 用户角色，用户列表反射回调
			gameUserCall(data){
				this.roleParam.type = data
			}
		}
	}
</script>

<style>
	.chat-chat-game{
		position: absolute;
		top: 80px;
		left: 20px;
		bottom: 80px;
		right: 20px;
		background-color: #FFFFFF;
		z-index: 11;
	}
	.chat-chat-game-title{
		height: 32px;
		line-height: 32px;
		background-color: #e8e8e8;
		padding: 0 10px;
		display: flex;
		justify-content: space-between;
	}
	.chat-chat-ot-close{
		cursor: pointer;
		padding: 0 10px;
	}
	.chat-chat-ot-name span{
		font-weight: bold;
		color: #ff5500;
	}
	.chat-chat-game-tabs{
		background-color: #e8e8e8;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0 10px;
	}
	.chat-chat-game-tab{
		padding: 2px 10px;
		border-radius: 4px 4px 0 0;
		cursor: pointer;
		user-select: none;
	}
	.chat-chat-game-tab-active{
		background-color: #FFFFFF;
	}
	.chat-chat-game-wrap{
		position: absolute;
		top: 56px;
		bottom: 10px;
		left: 10px;
		right: 10px;
		overflow: hidden;
	}
	.layui-table th,.layui-table td{
		font-size: 12px !important;
	}
</style>
